import React from 'react';
import { getSmoothStepPath } from 'react-flow-renderer';
import type { WorkflowEdgeProps } from 'flow/service/graph';
import { COLUMN_SPACING } from 'flow/service/graph';
import { EDGE_RADIUS } from './constants';
import { useAppSelector } from '~/store/reduxHooks';
import {
  selectEdgeState,
} from '~/dashboard/views/workflows/store/redux/selectors';
import { StyledBaseEdge } from './BaseEdge.styles';

function BaseEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  markerEnd,
  source,
  target,
  style,
}: WorkflowEdgeProps) {
  const edgeState = useAppSelector(state => selectEdgeState(state, [source, target]));
  const edgePath = getSmoothStepPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
    borderRadius: EDGE_RADIUS,
    // bends the edge close to the source node rather than at the middle
    centerX: sourceX + (COLUMN_SPACING / 2),
  });

  return (
    <StyledBaseEdge
      id={id}
      // @ts-ignore
      edgeState={edgeState}
      className="react-flow__edge-path"
      d={edgePath}
      markerEnd={markerEnd}
      style={style}
    />
  );
}

export default React.memo(BaseEdge);
